import type { DraftInput } from '../../../../shared/drafts';

function createQuestion(level: number): DraftInput['questions'][number] {
  return {
    prompt: `${level}. soru`,
    wagonStyle: 'wide',
    levels: [level],
    timeLimitSeconds: null,
    choices: [
      { text: 'Doğru enerji modülü', isCorrect: true },
      { text: 'Yanlış modül 1', isCorrect: false },
      { text: 'Yanlış modül 2', isCorrect: false },
    ],
  };
}

export function createOrbitalBridgeDraft(): DraftInput {
  return {
    title: 'Yeni Yörünge Köprüsü',
    templateKey: 'orbital-bridge',
    levelMode: 'manual',
    maxLevels: 1,
    trackTime: true,
    bridgeMode: 'challenge',
    timingMode: 'none',
    questions: [createQuestion(1)],
  };
}

export function resizeOrbitalBridgeDraft(draft: DraftInput, maxLevels: number): DraftInput {
  const safeLevels = Math.max(1, Math.min(10, Math.trunc(maxLevels)));
  const questions = Array.from({ length: safeLevels }, (_, index) => {
    const level = index + 1;
    const existing = draft.questions.find((question) => question.levels[0] === level);
    return { ...(existing ?? createQuestion(level)), levels: [level] };
  });
  return {
    ...draft,
    templateKey: 'orbital-bridge',
    levelMode: 'manual',
    maxLevels: safeLevels,
    trackTime: true,
    bridgeMode: draft.bridgeMode ?? 'challenge',
    timingMode: draft.timingMode ?? 'none',
    questions,
  };
}
